import { EntityMember } from './entity-model';

export const EMPTY_MEMBER_KEYS_ARRAY: string[] = [];
export const EMPTY_MEMBERS_ARRAY: EntityMember[] = [];

export const entityMembersFromKeys = (
  visibleMemberKeys: string[] = EMPTY_MEMBER_KEYS_ARRAY,
  addedMemberKeys: string[] = visibleMemberKeys,
): EntityMember[] => {
  const visibleKeysSet = new Set(visibleMemberKeys);
  const visibleKeys = Array.from(visibleKeysSet);

  return [
    ...visibleKeys.map((key) => ({ key, hidden: false })),
    ...Array.from(new Set(addedMemberKeys)).reduce<EntityMember[]>((result, key) => {
      if (!visibleKeysSet.has(key)) {
        result.push({ key, hidden: true });
      }

      return result;
    }, []),
  ];
};

export const visibleEntityMemberKeysFromMembers = (
  members: EntityMember[] = EMPTY_MEMBERS_ARRAY,
): string[] => {
  return members.reduce<string[]>((keys, member) => {
    if (!member.hidden) {
      keys.push(member.key);
    }

    return keys;
  }, []);
};

export const entityMemberKeysFromMembers = (
  members: EntityMember[] = EMPTY_MEMBERS_ARRAY,
): string[] => {
  return members.map(({ key }) => key);
};

export const reconcileEntityMembersWithVisibleKeys = (
  memberKeys: string[] = EMPTY_MEMBER_KEYS_ARRAY,
  members: EntityMember[] = EMPTY_MEMBERS_ARRAY,
): EntityMember[] => {
  const visibleKeysSet = new Set(memberKeys);
  const visibleMembers = entityMembersFromKeys(Array.from(visibleKeysSet));
  const hiddenMembersToPreserve = members.filter(
    ({ hidden, key }) => hidden && !visibleKeysSet.has(key),
  );

  return [...visibleMembers, ...hiddenMembersToPreserve];
};
